import { getOrderQueuePosition } from '@/services/ant-design-pro/order';
import { ClockCircleOutlined, UserOutlined } from '@ant-design/icons';
import { Badge, Tooltip, Typography } from 'antd';
import React, { useEffect, useState } from 'react';

const { Text } = Typography;

const OrderQueuePosition: React.FC = () => {
    const [queuePosition, setQueuePosition] = useState<API.OrderQueuePositionDto | null>(null);
    const [loading, setLoading] = useState(false);

    const fetchQueuePosition = async () => {
        try {
            setLoading(true);
            const response = await getOrderQueuePosition();
            if (response.code === 0 && response.data) {
                setQueuePosition(response.data);
            }
        } catch (error) {
            console.error('获取接单顺位失败:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        // 初始加载
        fetchQueuePosition();

        // 设置30秒定时器
        const interval = setInterval(() => {
            fetchQueuePosition();
        }, 30000);

        // 清理定时器
        return () => clearInterval(interval);
    }, []);

    if (!queuePosition) {
        return null;
    }

    const getPositionDisplay = () => {
        if (!queuePosition.is_in_queue) {
            return (
                <Tooltip title="当前不在接单队列中">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <ClockCircleOutlined style={{ color: '#d9d9d9' }} />
                        <Text type="secondary" style={{ fontSize: '12px' }}>
                            未排队
                        </Text>
                    </div>
                </Tooltip>
            );
        }

        return (
            <Tooltip title={`队列总长度: ${queuePosition.total_in_queue}`}>
                <Badge
                    count={queuePosition.position}
                    size="small"
                    style={{
                        backgroundColor: queuePosition.position <= 3 ? '#52c41a' : '#fa8c16',
                        fontSize: '10px',
                        fontWeight: 'bold'
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                        <UserOutlined style={{
                            color: queuePosition.position <= 3 ? '#52c41a' : '#fa8c16',
                            fontSize: '14px'
                        }} />
                        <Text
                            type={queuePosition.position <= 3 ? 'success' : 'warning'}
                            style={{
                                fontSize: '12px',
                                fontWeight: 'bold'
                            }}
                        >
                            第{queuePosition.position}位
                        </Text>
                    </div>
                </Badge>
            </Tooltip>
        );
    };

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '4px 8px',
            borderRadius: '4px',
            backgroundColor: queuePosition.is_in_queue ? '#f6ffed' : '#f5f5f5',
            border: `1px solid ${queuePosition.is_in_queue ? '#b7eb8f' : '#d9d9d9'}`,
            minWidth: '60px',
            justifyContent: 'center'
        }}>
            {getPositionDisplay()}
        </div>
    );
};

export default OrderQueuePosition; 